import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { AuthenticationService, NotificationService, EnvService, PayoutService} from '../../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PayoutRecord } from 'src/app/_models';

@Component({
  templateUrl: './payout-record-list.component.html'
})
export class PayoutRecordListComponent implements OnInit {
  records: Array<PayoutRecord> = [];
  loading = false;
  //pagination
  itemsPerPage = 20;
  pagingList = [20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = true;
  maxPageSize: number;

  sourceList = { 'Pay365': 7 };
  countryList = { 'Thailand': 'TH' };
  operatorList = ["AIS", "DTAC", "TMH"];

  yearList = [];
  monthList = [
    { "name": 'January', "value": 1 },
    { "name": 'February', "value": 2 },
    { "name": 'March', "value": 3 },
    { "name": 'April', "value": 4 },
    { "name": 'May', "value": 5 },
    { "name": 'June', "value": 6 },
    { "name": 'July', "value": 7 },
    { "name": 'August', "value": 8 },
    { "name": 'September', "value": 9 },
    { "name": 'October', "value": 10 },
    { "name": 'November', "value": 11 },
    { "name": 'December', "value": 12 },
  ];

  filterable = {
    source: 7,
    country: 'TH',
    operator: 'AIS',
    mtMonth: null,
    mtYear: null,
    payoutYear: null,
    payoutMonth: null,
    shortCode: '',
    keyword: '',
    account: '',
  };

  constructor(private authSvc: AuthenticationService,
    private envSvc: EnvService,
    private payoutSvc: PayoutService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    let currentYear = dte.getFullYear();
    this.yearList.push(currentYear);
    this.yearList.push(currentYear - 1);
    this.yearList.push(currentYear - 2);
    // goto previous 3 month
    if (dte.getMonth() >= 3) {
      this.filterable.mtYear = currentYear;
      this.filterable.mtMonth = dte.getMonth() - 3 + 1;
    } else {
      this.filterable.mtYear = currentYear - 1;
      this.filterable.mtMonth = 12 - dte.getMonth();
    }
  }

  search() {
    this.totalItems = 0;
    this.loadPage(1);
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  deleteRecord(record) {
    if (confirm("Are you sure to delete this record?")) {
      this.payoutSvc.deleteRecord(record.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Record deleted successfully!", "Delete Record");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting record, please try again later.", "Error");
        }
      })
    }
  }

  private loadPage(page = null) {
    this.loading = true;
    this.emptyResult = false;
    this.records = [];
    let params = this.formParam(page);
    // get page of items from api
    this.payoutSvc.getAll(params).pipe(first()).subscribe(data => {
      if (data && data.data) {
        this.loading = false;
        this.records = data.data.list;
        this.totalItems = data.data.total;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let mtFullMonth;
    if (this.filterable.mtMonth >= 10) {
      mtFullMonth = "" + this.filterable.mtYear + this.filterable.mtMonth;
    } else {
      mtFullMonth = this.filterable.mtYear + "0" + this.filterable.mtMonth;
    }

    let payoutFullMonth = null;
    console.log(this.filterable.payoutYear);
    console.log(this.filterable.payoutMonth);

    if(this.filterable.payoutYear != null && this.filterable.payoutMonth != null
      && this.filterable.payoutMonth != "null" && this.filterable.payoutYear != "null"){
      if (this.filterable.payoutMonth >= 10) {
        payoutFullMonth = "" + this.filterable.payoutYear + this.filterable.payoutMonth;
      } else {
        payoutFullMonth = this.filterable.payoutYear + "0" + this.filterable.payoutMonth;
      }
    }

    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword,
      operator: this.filterable.operator,
      account: this.filterable.account,
      source: this.filterable.source,
      country: this.filterable.country,
      mtMonth: mtFullMonth,
      payoutMonth: payoutFullMonth,

    }
    console.log(params);

    return params;
  }

}
